<template>
  <div class="aiTool">
    <div class="Tool_item" v-for="(item,index) in toolList">
      <div class="item_title" :class="index!=0?'margin_t':''">{{ item.title }}</div>
      <div class="list">
        <div v-for="(list,index) in item.list" @click="jumpChild(list,index)" class="item">
          <div class="item_box">
            <img alt="" class="item_img" :src="list.img">
            <h3 class="item_h">{{list.name }}</h3>
            <p class="item_p">{{list.guide}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      toolList: [
        {
          title: '绘画模型', list: [
            {
              id: 6,
              relation: 0,
              name: 'DALL-E 3绘画',
              guide: '无需遵循严格的指令格式，更能理解您想要什么，并准确地画出来。',
              img: require('./img/aiTool/dall.webp'),
            },
          ]
        },
        {
          title: '图片编辑', list: [
            {
              id: 1,
              relation: 0,
              name: '高清无损放大',
              guide: '无损放大图片，支持2倍、3倍、4倍放大，有效改善放大后图像的噪点与锯齿问题。',
              img: require('./img/aiTool/magnify.webp'),
            },
            {
              id: 2,
              relation: 0,
              name: '黑白图像上色',
              guide: '通过人工智能算法，识别黑白图像内容并填充色彩，使黑白图像变得鲜活。',
              img: require('./img/aiTool/colour.webp'),
            },
            {
              id: 3,
              relation: 0,
              name: '图像清晰度增强',
              guide: '利用Ai技术，智能识别图像主体以消除模糊，增强对比度和颜色，获得更清晰、更生动的视觉效果。',
              img: require('./img/aiTool/repair.webp'),
            },
            {
              id: 4,
              relation: 0,
              name: '图像风格转换',
              guide: '您可以将图像转换为卡通、铅笔、彩色铅笔或哥特式油画等多种风格。',
              img: require('./img/aiTool/cartoon.webp'),
            },
            {
              id: 5,
              relation: 0,
              name: '图像擦除',
              // mj_tool: 'imgRemove',
              guide: '快速移除照片中不需要的的物、人、文字。清理照片，美化图片',
              img: require('./img/aiTool/remove.webp'),
              // points:4,
            },

          ],
        },
        {
          title: '电商设计', list: [
            {
              id: 1,
              relation: 1,
              name: '背景移除',
              guide: '智能地识别图像的主体，将其视为前景并自动去除背景。适用于各种场景中的人物、动物等。',
              img: require('./img/aiTool/capture.webp'),
            },
            {
              id: 2,
              relation: 1,
              name: 'AI虚拟试衣  ',
              guide: '一键智能扩图，也可以对图片进行上下左右自定义像素的自动填充',
              img: require('./img/aiTool/fittingRoom.webp'),
            },
          ],
        },
        {
          title: '创意应用', id: 3, list: [
            {
              id: 1,
              relation: 2,
              name: '头像提取',
              guide: '它能够准确检测头部区域，一键裁剪并去除其他元素。',
              img: require('./img/aiTool/expansion.webp'),
            },

          ],
        },

      ],
    }
  },
  methods: {
    jumpChild(list, index) {
      console.log(list)
      console.log(index)
      console.log('跳转子集')
      // return
      if(list.name=='DALL-E 3绘画'){
        this.$router.push({
          path: '/creation?active=dall',
        });
      }else{
      this.$router.push({
        path: '/tool',
        query: {
          // linkTo:list.id,
          arrange: list.id,
          relation: list.relation,
        }
      });
    }
    },
  }
}
</script>
<style scoped lang="scss">
.aiTool {
  padding: 20px 20px 40px;
  overflow-y: auto;
  height: calc(100% - 40px);

  .Tool_item {
    .item_title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 20px;
      color: #fff;
      //margin-top: 20px;
      span {
        font-size: 12px;
        font-weight: 400;
      }

    }
    .margin_t{
      margin-top: 20px;
    }
    // 排除第一个的样式
    .list {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 10px;
      .item {

        transition: box-shadow .2s ease;
        border-radius: 10px;
        width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor:pointer;
        .item_box{
          border-radius: inherit;
          margin-left: auto;
          margin-right: auto;
          height: 100%;
          width: 100%;
          display: block;
          position: relative;
          overflow: hidden;
          background-color: #eee;

          .item_img{
            transition: transform .2s ease;
            aspect-ratio: auto 16 / 9;
            width: 100%;
            vertical-align: middle;
            object-fit: cover;
            -webkit-user-drag: none;
          }
          .item_h{
            font-weight: 700;
            font-size: 14px;
            margin: 10px 10px 0;
            min-height: 2em;
            display: flex;
            align-items: center;
            color: #666;
          }
          .item_p{
            color: #646464;
            margin:0px 10px 15px;
            font-size: 12px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }
        }
      }
      .item:hover {
        box-shadow:0px 0px 20px 0px #424242; /* 阴影效果 */
        .item_img{
          transform: scale(1.05); /* 放大图片 */
        }
      }

    }
  }
}

@media (max-width: 1299px) {
  .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr) !important;
    grid-gap: 24px;
  }
}
@media (max-width: 875px) {
  .list {
    display: grid;
    grid-template-columns: repeat(2, 1fr) !important;
    grid-gap: 24px;
  }
}

</style>